import styles from './IconDefault.module.scss';

export function IconUser() {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={styles.mediumIllustration}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.9985 4.15234C18.1571 4.15234 15.043 7.26646 15.043 11.1079C15.043 14.9494 18.1571 18.0635 21.9985 18.0635C25.84 18.0635 28.9541 14.9494 28.9541 11.1079C28.9541 7.26646 25.84 4.15234 21.9985 4.15234ZM6.22074 32.382C8.48369 25.8458 14.6935 21.1523 21.9995 21.1523C29.3054 21.1523 35.5152 25.8458 37.7782 32.382C38.7836 35.286 36.2015 37.8457 33.1284 37.8457H10.8706C7.79739 37.8457 5.21531 35.286 6.22074 32.382Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<circle
				cx="8.25"
				cy="23.8457"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<circle
				cx="5.75"
				cy="26.8457"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<path
				d="M19.7504 16.0634C15.909 16.0634 12.7949 12.9493 12.7949 9.10785C12.7949 5.26643 15.909 2.15234 19.7504 2.15234C23.5918 2.15234 26.7059 5.26643 26.7059 9.10785C26.7059 10.9869 25.9608 12.6919 24.75 13.9435"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M3.97073 30.3819C2.96532 33.2859 5.54737 35.8456 8.62051 35.8456H30.8781C33.9513 35.8456 36.5333 33.2859 35.5279 30.3819C33.265 23.8457 27.0552 19.1523 19.7493 19.1523C16.6498 19.1523 13.7476 19.9971 11.2604 21.4689"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	);
}
